import { seoUrlPart } from '@ecg-marktplaats/aurora-js-formatters';
import supportedBooleanOperators from '../../constants/supportedBooleanOperators';
import accentedCharacterList from '../../constants/accentedCharacterList';

const isNumber = (value: any): boolean =>
  /* (IE doesn't support Number.isNan() and Number.isFinite()) */
  /* eslint-disable-next-line no-restricted-globals */
  !isNaN(parseFloat(value)) && isFinite(value);

export const formatWord = (input?: string): string => {
  if (input === null || typeof input === 'undefined') {
    return '';
  }

  if (isNumber(input)) {
    return String(input);
  }

  return Array.from(input)
    .map((char) => {
      if (accentedCharacterList.includes(char)) {
        return encodeURIComponent(char);
      }
      const doSlugify = false;
      return encodeURIComponent(seoUrlPart(char, doSlugify));
    })
    .join('');
};

const changeCasing = (word: string) => {
  const shouldKeepCasing = supportedBooleanOperators.includes(word);
  return shouldKeepCasing ? word : word.toLowerCase();
};

export default function (input?: string): string {
  const data = input || '';
  return data.split(' ').map(formatWord).map(changeCasing).join('+');
}
